import { getMagicLink } from '@/api/magicLink';
import { useApiQuery } from '@/hooks/api';
import { queryKeys } from '@/shared/lib/queryKeys';

type MagicLinkInitResponse = {
  link?: string;
};

export function useMagicLinkInit(
  path: string | null | undefined,
  options?: { enabled?: boolean },
) {
  return useApiQuery<MagicLinkInitResponse | null>({
    queryKey: queryKeys.magicLink.init(path ?? ''),
    queryFn: async () => {
      if (!path) return null;
      return (await getMagicLink(path)) ?? null;
    },
    enabled: Boolean(path) && (options?.enabled ?? true),
    retry: false,
  });
}
